class VideoSlider {
  constructor() {
    this.init();
  }

  init() {
    if (typeof jQuery === 'undefined') {
      console.error('jQuery is required for Slick Slider');
      return;
    }

    const sliders = document.querySelectorAll('.video-slider');
    
    sliders.forEach(slider => {
      const $slider = jQuery(slider);
      const autoplay = slider.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(slider.dataset.autoplaySpeed) || 3000;
      const slidesToShow = parseInt(slider.dataset.slidesToShow) || 4;
      const slidesToShowTablet = parseInt(slider.dataset.slidesToShowTablet) || 3;
      const slidesToShowMobile = parseInt(slider.dataset.slidesToShowMobile) || 1;
      const arrows = slider.dataset.arrows === 'true';
      const dots = slider.dataset.dots === 'true';
      const infinite = slider.dataset.infinite === 'true';

      $slider.slick({
        autoplay: autoplay,
        autoplaySpeed: autoplaySpeed,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        arrows: arrows,
        dots: dots,
        infinite: infinite,
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: slidesToShowTablet,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: slidesToShowMobile,
              slidesToScroll: 1,
              arrows: false
            }
          }
        ]
      });

      // Handle video play buttons
      this.initVideoPlayers(slider);
    });
  }

  initVideoPlayers(slider) {
    const playButtons = slider.querySelectorAll('.video-slider__play-button');
    
    playButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const videoType = button.dataset.videoType;
        const wrapper = button.closest('.video-wrapper');
        
        if (videoType === 'uploaded') {
          // Handle uploaded video
          const videoContainer = wrapper.querySelector('.video-slider__video-container');
          const video = videoContainer.querySelector('video');
          const thumbnail = wrapper.querySelector('.video-slider__thumbnail, .video-slider__video');
          
          // Hide thumbnail and button, show video
          if (thumbnail) thumbnail.style.display = 'none';
          button.style.display = 'none';
          videoContainer.style.display = 'block';
          
          // Play the video
          video.play();
        } else if (videoType === 'url') {
          // Handle URL-based video (YouTube/Vimeo)
          const videoUrl = button.dataset.videoUrl;
          const iframeContainer = wrapper.querySelector('.video-slider__iframe-container');
          
          if (!videoUrl) return;

          const embedUrl = this.getEmbedUrl(videoUrl);
          if (!embedUrl) {
            console.error('Invalid video URL');
            return;
          }

          // Create iframe
          const iframe = document.createElement('iframe');
          iframe.src = embedUrl + '?autoplay=1';
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
          iframe.allowFullscreen = true;
          
          // Hide thumbnail and button, show iframe
          const thumbnail = wrapper.querySelector('.video-slider__thumbnail');
          if (thumbnail) thumbnail.style.display = 'none';
          button.style.display = 'none';
          iframeContainer.style.display = 'block';
          iframeContainer.appendChild(iframe);
        }
      });
    });
  }

  getEmbedUrl(url) {
    // YouTube
    const youtubeRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
    const youtubeMatch = url.match(youtubeRegex);
    if (youtubeMatch) {
      return `https://www.youtube.com/embed/${youtubeMatch[1]}`;
    }

    // Vimeo
    const vimeoRegex = /vimeo\.com\/(?:video\/)?(\d+)/;
    const vimeoMatch = url.match(vimeoRegex);
    if (vimeoMatch) {
      return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
    }

    return null;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new VideoSlider();
  });
} else {
  new VideoSlider();
}

// Reinitialize after Shopify section updates
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    setTimeout(() => {
      new VideoSlider();
    }, 100);
  });
}

